import { NgModule, Type } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AppBarComponent, AppPageComponent, AppSidenavComponent } from "common";
import { DASHBOARD_PAGES, DashboardPageSlug } from "./dashboard.data";
import { ConversionMetricsComponent } from "./features/conversion-metrics/conversion-metrics.component";
import { HomeComponent } from "./features/home/home.component";
import { PartnerScorecardComponent } from "./features/partner-scorecard/partner-scorecard.component";
import { PipelineHealthComponent } from "./features/pipeline-health/pipeline-health.component";
import { SmartInsightsComponent } from "./features/smart-insights/smart-insights.component";
import { TrendMetricsComponent } from "./features/trend-metrics/trend-metrics.component";
import { DashboardBreadcrumbComponent } from "./shared/dashboard-breadcrumb/dashboard-breadcrumb.component";
import { OAuthGuard } from "../../../guards/oauth.guard";
import { appBarData, appBarDropdownData } from "../../app.data";
import { AppPageResolver, AppSidenavItemsResolver } from "../../app.resolver";
import { AppBarDropdownComponent } from "../../shared/app-bar-dropdown/app-bar-dropdown.component";

/** Every sub-page's screen; a slug without one does not compile. */
const DASHBOARD_PAGE_COMPONENTS: Record<DashboardPageSlug, Type<unknown>> = {
  [DashboardPageSlug.SMART_INSIGHTS]: SmartInsightsComponent,
  [DashboardPageSlug.PIPELINE_HEALTH]: PipelineHealthComponent,
  [DashboardPageSlug.CONVERSION_METRICS]: ConversionMetricsComponent,
  [DashboardPageSlug.TREND_METRICS]: TrendMetricsComponent,
  [DashboardPageSlug.PARTNER_SCORECARD]: PartnerScorecardComponent,
};

/** One child route per dashboard sub-page; `data.dashboardPage` carries the page definition to the component. */
export function dashboardPageRoutes(): Routes {
  return DASHBOARD_PAGES.map(page => ({
    path: page.slug,
    component: DASHBOARD_PAGE_COMPONENTS[page.slug],
    title: `${page.title} – Idea Financial Partner`,
    data: { dashboardPage: page },
  }));
}

const routes: Routes = [
  {
    path: "dashboard",
    component: AppPageComponent,
    canActivate: [OAuthGuard],
    data: {
      appBar: appBarData(),
      appBarDropdown: appBarDropdownData(),
    },
    resolve: {
      appPage: AppPageResolver,
      appSidenav: AppSidenavItemsResolver,
    },
    children: [
      {
        path: "",
        outlet: "app-bar",
        component: AppBarComponent,
        children: [
          {
            path: "",
            outlet: "title",
            component: DashboardBreadcrumbComponent,
          },
          {
            path: "",
            outlet: "right",
            component: AppBarDropdownComponent,
          },
        ],
      },
      {
        path: "",
        outlet: "sidenav-content",
        component: AppSidenavComponent,
      },
      {
        path: "",
        title: "Dashboards – Idea Financial Partner",
        component: HomeComponent,
      },
      ...dashboardPageRoutes(),
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DashboardRoutingModule { }
